@if (hasContent()) {
  <div
    class="inline-flex items-center gap-1 text-sm font-semibold text-gray-600 dark:text-gray-300"
    aria-live="polite"
  >
    @if (showVersion()) {
      <span [class]="statusPillClass('neutral')">
        {{ versionLabel() }}
      </span>
    }
    @if (showOrgStatus()) {
      <div class="flex items-center gap-2">
        <span [class]="statusPillClass(statusTone())">{{ statusLabel() }}</span>
      </div>
    }
    @for (badge of statusCountBadges(); track badge.status) {
      <span [class]="statusPillClass(badge.tone)">
        {{ badge.count }}
        {{ badge.label }}
      </span>
    }
    @if (statusHint() && showHint()) {
      <app-hint class="mt-px" [hint]="statusHint()" label="Stato modulo" />
    }
  </div>
}
